import React from 'react'

const faqs = [
  {
    id: 1,
    answer:
      "ACD software automatically routes Incoming Calls to the next available agent, ensuring that callers are quickly and efficiently connected with an agent.",
    question: "Automatic Call Distribution (acd)",
  },
  {
    id: 2,
    answer:
      "IVR Systems can provide callers with self-service options such as checking account balances, placing orders, or accessing frequently asked questions.",
    question: "Interactive Voice Response (ivr)",
  },
  {
    id: 3,
    answer:
      "Call center agents must be able to manage Incoming call volumes, which is often accomplished through queue management tools that display wait times, queue lengths, and other pertinent data.",
    question: "Queue Management",
  },
  {
    id: 4,
    answer:
      "In some call centers, Incoming Calls are forwarded to representatives equipped to handle them.",
    question: "Skill based Routing",
  },
  {
    id: 4,
    answer:
      "To plan agents' schedules, forecast call volumes, and manage staffing levels to ensure adequate coverage during call peaks, call center managers can use workforce management software.",
    question: "Workforce Management",
  },
  {
    id: 4,
    answer:
      "Agents can deliver more individualised service by using CRM software to give them a complete picture of the customer's history and current situation.",
    question: "Integration Of Customer Relationship Management (crm) Software",
  },
  // More questions...
];

function InboundSolution() {
  return (
    <div className="bg-white py-2">
      <div className="flex flex-col md:flex-row items-center justify-between p-6 ">
        {/* Left Content */}
        <div className="md:w-1/2 p-4">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Providing Exceptional Service Through Inbound Call Centers
          </h1>
          <ul className="list-disc list-inside text-gray-600 space-y-2">
            <p className="text-lg text-gray-600">
              A Call Center that manages incoming calls from customers or
              clients is referred to as an inbound call center. The
              representatives in an Inbound Call Center deliver customer
              service, solve problems, respond to inquiries, and manage various
              types of incoming calls. Inbound call centers are a crucial
              element of the customer service offered by many companies. These
              call centers address inbound calls from clients with questions,
              complaints, or issues related to a company's products or services.
              In this post, we will examine the nature of inbound call centers,
              their operational processes, and the strategies that companies can
              implement to improve their inbound call center operations.
            </p>
          </ul>
        </div>

        {/* Right Image */}
        <div className="md:w-1/2 p-4">
          <img
            src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1344&h=1104&q=80"
            alt="Placeholder"
            className="rounded-lg shadow-lg"
          />
        </div>
      </div>

      {/* section */}

      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8">
          <h2 className="text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
            An Inbound Call Center May Have The Following Features:
          </h2>
          {/* <p className="mt-6 max-w-2xl text-base/7 text-gray-600">
            Toll-Free Calling is a thing in lots of countries, and it happens by
            setting aside special phone numbers called Toll-Free 800 Numbers.
            People can dial these numbers without worrying about getting
            charged. Check out these examples:
          </p> */}
          <div className="mt-20">
            <dl className="space-y-16 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-16 sm:space-y-0 lg:gap-x-10">
              {faqs.map((faq) => (
                <div key={faq.id}>
                  <dt className="text-base/7 font-semibold text-gray-900">
                    {faq.question}
                  </dt>
                  <dd className="mt-2 text-base/7 text-gray-600">
                    {faq.answer}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>

      {/* section */}
      <div className="flex flex-col md:flex-row items-center justify-between p-6 ">
        {/* Left Content */}
        <div className="md:w-1/2 p-4">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Why Choose Our Inbound Call Center Solutions
          </h1>
          <ul className="list-disc list-inside text-gray-600 space-y-6">
            <li>
              Customers contact businesses when they require assistance, which
              can help resolve issues quickly and effectively.
            </li>
            <li>
              Call Centers can earn money by offering clients upsell and
              cross-sell possibilities throughout their agent interactions.
            </li>
            <li>
              Through customer feedback, Inbound Call Centers allow businesses
              to gain critical customer insights.
            </li>
            <li>Handle large amounts of calls without sacrificing quality.</li>
           
          </ul>
        </div>

        {/* Right Image */}
        <div className="md:w-1/2 p-4">
          <img
            src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1344&h=1104&q=80"
            alt="Placeholder"
            className="rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
  );
}

export default InboundSolution